import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DarkModeToggleComponent } from '@shared/components/dark-mode-toggle/dark-mode-toggle.component';
import { AutorizacaoService } from '@shared/infra/autorizacao/autorizacao.service';
import { SliceAuthService } from './core/autenticacao/slice-auth.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, DarkModeToggleComponent],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(
    private sliceAuthService: SliceAuthService,
    private autorizacaoService: AutorizacaoService
  ) {}

  ngOnInit(): void {
    this.sliceAuthService.appInit();
    this.autorizacaoService.loadAutorizacoes();
  }
}
